// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TabProps } from "@insite/mobius/Tab";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import { color, styledScrollbar } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: fontConfig.smallSingleLine.size,
            lineHeight: fontConfig.smallSingleLine.lineHeight,
            weight: fontConfig.weight.semiBold,
            css: css`
                margin-bottom: 0;
            `,
        },
        css: css`
            position: relative;
            background-color: ${color("common.ui8")};
            padding: 8px 16px 6px;
            border-radius: 8px 8px 0 0;
            cursor: pointer;
            border: unset;
            &:hover {
                border: unset;
                background-color: ${color("common.ui10")};
            }

            &:focus {
                outline: none;
            }

            ${({ selected }: TabProps) =>
                selected &&
                css`
                    z-index: 1;
                    background-color: ${color("common.ui11")};
                    color: ${color("common.ui1")};
                    &,
                    &:hover {
                        border: unset;
                    }
                `}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                padding: 0 2px 0 0;
                position: relative;

                & > li:not(:last-child) {
                    margin-right: 12px;
                }

                &:after {
                    content: "";
                    position: absolute;
                    display: block;
                    background-color: ${color("common.border")};
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 1px;
                    width: 100%;
                }

                ${styledScrollbar()}
            `,
            tabContent: css`
                position: relative;
                margin-top: 0;
                padding: 0 0 5px 0;
                border-top: 0;
                border-bottom: 0;
                & div[class^="MobileDataTableRowStyle"]:first-child {
                    border-top: 0;
                }
            `,
            wrapper: css`
                width: 100%;
            `,
        },
    },
} as xBaseTheme["tab"];
